var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-content"},[_c('div',{staticClass:"header-left"},[_c('h4',[_vm._v(_vm._s(_vm.$t("markets-history")))])]),_vm._v(" - "),_c('div',{staticClass:"header-right"},[_c('DayChanger')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }